import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import './AppTab.scss';

const TabItem = ({
    label, active,
    onClick
}) => {
    return (
        <div
            className={['atm-item', (active ? 'active' : '')].join(' ')}
            id={`tab-item-${label}`.toLowerCase()}
            onClick={onClick}
        >
            { label }
        </div>
    );
};

const TabContent = ({
    label, children
}) => (children);

const AppTab = ({
    children,
    afterTabs
}) => {
    const [ itemNb, setSelectedItem ] = useState(0);
    const safeChildren = (Array.isArray(children) ? children : [children]);
    const tabItems = [];
    safeChildren.forEach((rawElement, idx) => {
        const { label } = rawElement.props;
        tabItems.push(
            <TabItem
                key={`${label}_${idx}`}
                label={label}
                active={itemNb === idx}
                onClick={() => setSelectedItem(idx)}
            />
        );
    });
    let ActiveElement = [(itemNb < safeChildren.length ? safeChildren[itemNb] : <React.Fragment />)];
    return (
        <div className="app-tab-module">
            <div className="atm-tab-list">
                {tabItems}
                {afterTabs ? 
                    <div className="d-flex ps-1 pe-1 justify-content-end align-items-center w-100" style={{height: 48}}>
                        {afterTabs}
                    </div> : null}
            </div>
            <div className="atm-tab-content">
                {ActiveElement[0]}
            </div>
        </div>
    );
};

AppTab.Item = TabContent;

export default AppTab